import _styled from "styled-components";
import React from "react";
import { hasItems } from "~/features/app/utils";
import { EditorialCard } from "~/features/card/editorial-card";
export type MediaCardsCardViewProps<TLink = unknown> = {
  headline?: string | null;
  links?: TLink[] | null;
  media?: React.ReactNode;
  renderLink: (link: TLink, index: number) => React.ReactNode;
  text?: React.ReactNode;
};
export function MediaCardsCardView<TLink = unknown>({
  headline,
  links,
  media,
  renderLink,
  text
}: MediaCardsCardViewProps<TLink>) {
  return <EditorialCard headline={headline ?? undefined} hasPlusIcon={false} text={text} media={media} footer={hasItems(links) ? <_StyledDiv>{links.map((link, idx) => renderLink(link, idx))}</_StyledDiv> : undefined} />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "media-cards-card___StyledDiv",
  componentId: "sc-78dfhl-0"
})({
  "marginTop": "2.4rem",
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "1.6rem"
});